export default function SidePanel({ children, title, isOpen, onToggle }) {
  return (
    <>
      <div
        className={`
          hidden md:block fixed top-[91px] right-4 z-[1000]
          w-96 max-h-[calc(100vh-6.5rem)]
          glass-hover bg-white/85 backdrop-blur-xl rounded-2xl shadow-2xl
          border border-white/40
          transition-all duration-300 ease-in-out
          ${isOpen ? "translate-x-0 opacity-100" : "translate-x-[110%] opacity-0"}
        `}
      >
        <div className="flex items-center justify-between px-5 py-3 border-b border-gray-200/50">
          <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
          <button
            onClick={onToggle}
            className="btn-pop w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-200/50 transition text-gray-500"
          >
            ✕
          </button>
        </div>
        <div className="overflow-y-auto max-h-[calc(100vh-10.5rem)] p-4">
          {children}
        </div>
      </div>

      <div
        className={`
          md:hidden fixed left-0 right-0 bottom-0 z-[1002]
          glass-hover bg-white/90 backdrop-blur-xl rounded-t-3xl shadow-2xl
          border-t border-white/40
          transition-all duration-300 ease-in-out
          ${isOpen ? "translate-y-0" : "translate-y-full"}
        `}
        style={{ maxHeight: "70vh" }}
      >
        <div className="flex justify-center pt-3 pb-1">
          <div className="w-10 h-1 bg-gray-300 rounded-full"></div>
        </div>
        <div className="flex items-center justify-between px-5 py-2 border-b border-gray-200/50">
          <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
          <button
            onClick={onToggle}
            className="btn-pop w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-200/50 transition text-gray-500"
          >
            ✕
          </button>
        </div>
        <div className="overflow-y-auto p-4" style={{ maxHeight: "calc(70vh - 5rem)" }}>
          {children}
        </div>
      </div>
    </>
  );
}
